import DOMPurify from 'dompurify';

if (window.trustedTypes && window.trustedTypes.createPolicy) {
  window.trustedTypes.createPolicy('default', {
    createHTML: (string) =>
      DOMPurify.sanitize(string, {
        RETURN_TRUSTED_TYPE: true,
        // ag-grid templates in the vendored Refinitiv widgets rely on these.
        ADD_ATTR: ['ref', 'comp-id'],
        CUSTOM_ELEMENT_HANDLING: { tagNameCheck: /^ag-/ },
      }),
    createScriptURL: (string) =>
      DOMPurify.sanitize(string, { RETURN_TRUSTED_TYPE: true }),
    createScript: (string) =>
      DOMPurify.sanitize(string, { RETURN_TRUSTED_TYPE: true }),
  });
}
